import { useState, useContext, useEffect, useRef } from 'react'
import { Form, Button, Col } from 'react-bootstrap'
import { ProspectContext } from './../contexts/ProspectContext'
import Loader from './Loader'
import { prepareBancontactPayment, proceedBancontactPayment } from '../utils/payment'

const BancontactForm = ({ processingBancontactPayment, handleError, handleSuccess, handleLoading, loading }) => {
  const { state } = useContext(ProspectContext)
  const [complete, setComplete] = useState(false)
  const processedPaymentIntents = useRef(new Set())

  const handleSubmit = async (evt) => {
    evt.preventDefault()

    // Prevent duplicate submissions
    if (loading) return

    const form = evt.currentTarget
    if (form.checkValidity() === false) {
      evt.stopPropagation()
      setComplete(true)
    } else {
      const firstName = form.elements.firstName.value
      const lastName = form.elements.lastName.value

      // Create payload fresh for each submission
      const payload = {
        PaymentMethod: 'bancontact',
        ProspectId: state.prospect.prospectId,
        SelectedPlan: state.selectedPlan.id,
        AccountHolder: [firstName, lastName].join(' ')
      }

      handleLoading(true)
      setComplete(true)

      try {
        await prepareBancontactPayment(payload)
        // User will be redirected to Bancontact, so we won't reach here
      } catch (error) {
        handleError(error)
        handleLoading(false)
      }
    }
  }

  useEffect(() => {
    if (processingBancontactPayment.status && processingBancontactPayment.source) {
      // Prevent duplicate processing of the same payment intent
      if (processedPaymentIntents.current.has(processingBancontactPayment.source)) {
        console.log('BancontactForm - Payment intent already being processed, skipping duplicate call')
        return
      }

      // Mark as being processed
      processedPaymentIntents.current.add(processingBancontactPayment.source)

      handleLoading(true)

      // Create fresh payload object (don't mutate)
      const payload = {
        PaymentMethod: 'bancontact',
        ProspectId: state.prospect.prospectId,
        SelectedPlan: state.selectedPlan.id,
        PaymentSource: processingBancontactPayment.source
      }

      proceedBancontactPayment(payload)
        .then((certificateUrl) => {
          handleSuccess({
            completed: true,
            certificate: certificateUrl
          })
        })
        .catch((error) => {
          handleError(error)
        })
        .finally(() => {
          handleLoading(false)
        })
    }
  }, [
    processingBancontactPayment.status,
    processingBancontactPayment.source,
    state.prospect.prospectId,
    state.selectedPlan.id,
    handleLoading,
    handleSuccess,
    handleError
  ])

  return (
    <>
      {loading && (
        <Loader loadingText='Betaling verwerken…' />
      )}
      <div className='BancontactForm' {...(loading ? { style: { display: 'none' } } : {})}>
        <Form noValidate validated={complete} onSubmit={handleSubmit}>
          <Form.Row>
            <Form.Group as={Col} md='6' controlId='firstName'>
              <Form.Label>Voornaam</Form.Label>
              <Form.Control type='text' name='firstName' required />
              <Form.Control.Feedback type='invalid'>Voornaam veld is verplicht</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md='6' controlId='lastName'>
              <Form.Label>Naam</Form.Label>
              <Form.Control type='text' name='lastName' required />
              <Form.Control.Feedback type='invalid'>Naam veld is verplicht</Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Button type='submit' disabled={loading}>
            Onderschrijven
          </Button>
        </Form>
      </div>
    </>
  )
}

export default BancontactForm
